import { gql } from "@apollo/client";

export const GET_TENANTS = gql`
  query GetTenants {
    tenants {
      id
      name
      description
      subscription {
        name
        id
      }
      defaultUnit
      alias
    }
  }
`;

export const GET_SUBSCRIPTIONS = gql`
  query AppSubscriptions {
    appSubscriptions {
      id
      name
    }
  }
`;

export const GET_USERS_BY_TENANT = gql`
  query GetUsersByTenant($tenantId: ID!) {
    users(tenantId: $tenantId) {
      id
      email
      tenantName
      createdBy
      isInactive
      role {
        name
      }
      firstName
      lastName
    }
  }
`;

export const GET_USERS_FOR_FOUNDRY = gql`
  query GetUsersForFoundry {
    usersForFoundry {
      items {
        tenantId
        tenantName
        users {
          createdBy
          dateCreated
          dateModified
          defaultUnit
          email
          description
          firstName
          id
          isInactive
          lastName
          preferences
          modifiedBy
          role {
            description
            id
            name
          }
          tenantId
          tenantName
        }
      }
      totalItemCount
      totalPageCount
    }
  }
`;

export const GET_MEASUREMENT_TECHNOLOGY = gql`
  query GetMeasurementTechnologies {
    getMeasurementTechnologies {
      id
      name
      description
      createdBy
      dateCreated
    }
  }
`;

export const GET_PROJECT_GROUPS = gql`
  query GetProjectGroups($tenantId: ID!) {
    projectGroups(filters: { tenantId: $tenantId }) {
      id
      location
      name
      ogmpVersions
      operator
      publicId
      segment
      coordinates
      assetType
      sites {
        country
        customerName
        description
        id
        name
        groupStartYear
        groupEndYear
      }
    }
  }
`;

export const GET_GROUP_ASSET_TYPES = gql`
  query GetGroupAssetTypes {
    groupAssetTypes(filters: {}) {
      name
      segment
      id
    }
  }
`;

export const GET_COUNTRIES = gql`
  query GetCountries {
    countries
  }
`;

export const GET_GROUP_VERSIONS = gql`
  query GroupVersions($tenantId: ID) {
    groupVersions(tenantId: $tenantId) {
      id
      ogmpLevel
      ogmpYear
      operator
      plannedSiteSurveys
      productionCh4
      productionCh4Unit
      assetType
      comments
      equity
      equityFraction
      groupId
      location
      name
      publicId
      reportingLevel
      segment
      typeOfEquity
      uncertaintyFraction
    }
  }
`;

export const GET_OGMP_CATEGORIES = gql`
  query GetOgmpCategories($tenantId: ID, $isOgmp: Boolean) {
    tenantSourceCategories(tenantId: $tenantId, isOgmp: $isOgmp) {
      id
      name
      parentCategoryId
      status
    }
  }
`;

export const GET_GROUP_VERSION_OGMP_CATEGORIES = gql`
  query GetGroupVersionOgmpCategories($groupVersionId: ID!) {
    getGroupVersionOGMPCategories(groupVersionId: $groupVersionId) {
      id
      frequency
      measurementTechnologyId
      ogmpCategoryId
      l4Method
      sampleSize
      sampleSizeUnit
      uncertaintyFraction
      dataSource
    }
  }
`;

export const GET_ELIGIBLE_SITES_FOR_GROUP_VERSION = gql`
  query EligibleSitesForGroupVersion($groupVersionId: ID!) {
    eligibleSitesForGroupVersion(groupVersionId: $groupVersionId) {
      id
      name
    }
  }
`;

export const GET_SITE_MEASUREMENTS_BY_PROJECT_GROUP_VERSION = gql`
  query GetSiteMeasurementsByProjectGroupVersion($tenantId: ID!, $projectGroupVersionId: ID!) {
    getSiteMeasurementsByProjectGroupVersion(tenantId: $tenantId, projectGroupVersionId: $projectGroupVersionId) {
      project {
        id
        name
      }
      id
      measurementTimestamp
      startTime
      endTime
      emissions
      emissionsUnit
      areaCovered
      areaCoveredUnit
      atmosphericPressure
      atmosphericPressureUnit
      detectionThreshold
      environmentalUncertainty
      minimumDetectionLimit
      minimumDetectionUnit
      measurementProvider
      reconciliationReadyStatus
      rootCauseQuestion1_comment
      rootCauseQuestion1_yesNo
      rootCauseQuestion2_comment
      rootCauseQuestion2_yesNo
      sourceLevelUncertaintyFraction
      spatialResolution
      status
      summary
      temperature
      temperatureUnit
      uncertaintyFraction
      windSpeed
      windSpeedUnit
      sourceMeasurements {
        emissions
        emissionsUnit
        name
        id
        summary
        parentOgmpCategory
        versionOgmpCategoryId
      }
      measurementTechnology {
        name
      }
    }
  }
`;

export const GET_REGIONS_BY_TENANT_ID = gql`
  query GetRegionsByTenantId($tenantId: ID!) {
    getRegionsByTenantId(tenantId: $tenantId) {
      id
      name
      description
      defaultAvgGasComposition
      tenantId
    }
  }
`;

export const GET_SUB_REGIONS_BY_TENANT_ID = gql`
  query GetSubRegionsByTenantId($tenantId: ID!) {
    getSubRegionsByTenantId(tenantId: $tenantId) {
      id
      name
      description
      tenantId
    }
  }
`;

export const GET_FLAT_TABLE_REFRESH_STATUS = gql`
  query FlatTableRefreshStatus {
    flatTableRefreshStatus {
      status
      inProgress
      lastRefreshAt
      nextScheduledAt
      rowsAffected
      durationSeconds
      message
      dateCreated
    }
  }
`;

export const GET_TENANT_DISPLAY_FEATURES = gql`
  query TenantDisplayFeatures($tenantId: ID!) {
    tenantDisplayFeatures(tenantId: $tenantId) {
      tenantId
      usesDefault
      items {
        path
        name
        depth
        enabled
        defaultEnabled
        hasChildren
      }
    }
  }
`;
